import axios from 'axios';
import { getSupportContext } from './auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const supportContext = getSupportContext();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (supportContext?.tenantId) {
    config.headers['X-Act-As-Tenant'] = supportContext.tenantId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;